import React, {Component} from 'react';

import {Typography, Modal, Button, MenuItem, TextField} from '@material-ui/core'
import {FormControl, Select, OutlinedInput, InputLabel} from '@material-ui/core'

import ErrorPopup from '../ErrorPopup.js';

import {connect} from 'react-redux';
import {authLogIn} from '../../ReduxActions/AuthAction'

import '../../stylesheets/App.css'

/**
 * Log In Modal
 * @param open - boolean
 * @param handleClose - function
 * @param
 */
class SignIn extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      logInView: true,
      signUpView: false,
      email: '',
      password: '',
      verifyPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
      errorMessage: '',

    }
  

  }
  
  handleError = () => {
    console.log("Log In error");
    this.setState({
      error: true,
      errorMessage: 'temporary error message'
    })
  }

  handleChange = e => {
    if (e.target) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

  };

  handleLoginSubmit = e => {
    e.preventDefault();
    console.log("email: ", this.state.email)
    this.props.dispatchLogin(this.state.email, this.state.password);
    console.log("Login Submit");
  }

  handleSignupSubmit = e => {
    e.preventDefault();
    console.log("Sign Up Submit");
  }

  resetState = e => {
    this.setState({
      email: '',
      password: '',
      verifyPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
      errorMessage: '',
    })
  }

  redirectLogIn = e => {
    e.preventDefault();
    this.resetState(e);
    this.setState({
      logInView: true,
      signUpView: false
    })
  }

  redirectSignUp = e => {
    // close current modal screen and open another modal screen
    // Redirect to create account modal
    e.preventDefault();
    this.resetState(e);
    this.setState({
      logInView: false,
      signUpView: true,
    })
  }



  render() {
    console.log("Render modal");

    
    return (
      <div>
        {
          this.state.logInView ? (
            // Log in view
            <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.props.open}
            onClose={this.props.handleClose.bind(this)}
            >
    
            <div className="modal-css">
              <ErrorPopup hideDuration={6000} errorOpen={this.state.error} vertical='top' horizontal='center' handleErrorClose={() => { this.setState({error: false})}} errorMessage={this.state.errorMessage} />
              <Typography variant="h5" style={{textAlign: 'center', marginBottom: 15}}>Sign In</Typography>
              <form onSubmit={this.handleLoginSubmit} style={{margin: 5}}>
                <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
                  <TextField
                    required
                    id="outlined-email"
                    label="Email"
                    name="email"
                    value={this.state.email}
                    onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                  />
    
                  <TextField
                    required
                    type="password"
                    id="outlined-password"
                    label="Password"
                    name="password"
                    value={this.state.password}
                    onChange={this.handleChange}
                    margin="normal"
                    variant="outlined"
                  />
                </div>
    
                <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginTop: 15}}>
                  <Button size="large" fullWidth onClick={this.redirectSignUp} color="inherit" variant="outlined" style={{color: 'black', margin: 5, flex: 0.5}}>Create Account</Button>
    
                  <Button size="large" fullWidth onClick={this.handleLoginSubmit} variant="contained" style={{color: 'white', backgroundColor: "#45b97c", margin: 5, flex: 0.5}}>Login</Button>
                </div>
              </form>
            </div>
              
            </Modal>
          ) : (
            // Sign Up View
            <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={this.props.open}
            onClose={this.props.handleClose.bind(this)}
            >
              <div className="modal-css">
                <ErrorPopup hideDuration={6000} errorOpen={this.state.error} vertical='top' horizontal='center' handleErrorClose={() => {this.setState({error: false})}} errorMessge={this.state.errorMessage} />
                <Typography variant="h5" style={{textAlign: 'center', marginBottom: 15}}>Create Account</Typography>
                <form onSubmit={this.handleSignupSubmit}>
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginBottom: 10}}>
                    <TextField
                      style={{flex: 1, margin: 5}}
                      required
                      id="outlined-email"
                      label="Email"
                      name="email"
                      value={this.state.email}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginBottom: 10}}>
                    <TextField
                      style={{flex: 1, margin: 5}}
                      required
                      id="outlined-password"
                      label="Password"
                      type="password"
                      name="password"
                      value={this.state.password}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginBottom: 10}}>
                    <TextField
                      style={{flex: 1, margin: 5}}
                      required
                      id="outlined-password"
                      label="Verify Password"
                      type="password"
                      name="verifyPassword"
                      value={this.state.verifyPassword}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginBottom: 10}}>
                    <TextField
                      style={{flex: 0.5, margin: 5}}
                      required
                      id="outlined-first-name"
                      label="First Name"
                      name="firstName"
                      value={this.state.firstName}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                    <TextField
                      style={{flex: 0.5, margin: 5}}
                      required
                      id="outlined-last-name"
                      label="Last Name"
                      name="lastName"
                      value={this.state.lastName}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
        
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginBottom: 10}}>
                    <TextField
                      style={{flex: 1, margin: 5}}
                      required
                      id="outlined-phone"
                      label="Phone Number"
                      name="phone"
                      value={this.state.phone}
                      onChange={this.handleChange}
                      margin="normal"
                      variant="outlined"
                    />
                  </div>
      
      
                  <div style={{display: 'flex', flexDirection: 'row', flex: 1, marginTop: 15}}>                    
                    <Button size="large" fullWidth onClick={this.redirectLogIn} color="inherit" variant="outlined" style={{color: 'black', margin: 5, flex: 0.5}}>Login</Button>
      
                    <Button size="large" fullWidth onClick={this.handleSignupSubmit} variant="contained" style={{color: 'white', backgroundColor: "#45b97c", margin: 5, flex: 0.5}}>Create Account</Button>
                  
                  </div>
                </form>
              </div>
            </Modal>
          )
        }

      </div>
    )
    // else {
    //   return (
    //     <SignUpView />
    //   )
    // }

  }
}

const mapStateToProps = (state) => {
  return {
    Auth: state.Auth,
    Cart: state.Cart
  }
}

const mapDispatchToProps = {
  dispatchLogin: (email, password) => authLogIn(email, password)
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);